<template>
  <div>
    
    <!-- Cards -->
    <div class="popular-cards">
      <div class="container">
        <div class="row">
          <div class="col-lg-4 col-md-6">
            <div class="popular-card">
              <img v-if="row.image6" :src="row.image6" class="mb-4 img-view img-fluid" :alt="row.title6" />
              <div class="bg-title main-color mb-1" 
                    v-html="row.title6"
                    :style="'color:'+row.color6+' !important'">
              </div>
              <router-link v-if="row.button6" :to="row.redirect6" 
                  class="btn-line btn-line-gray">{{ row.button6 }} 
              </router-link>
            </div>
          </div>

          <div class="col-lg-4 col-md-6">
            <div class="popular-card">
              <img v-if="row.image7" :src="row.image7" class="mb-4 img-view img-fluid" :alt="row.title7" />
              <div class="bg-title main-color mb-1" 
                    v-html="row.title7"
                    :style="'color:'+row.color7+' !important'">
              </div>
              <router-link v-if="row.button7" :to="row.redirect7" 
                  class="btn-line btn-line-gray">{{ row.button7 }} 
              </router-link>
            </div>
          </div>

          <div class="col-lg-4 col-md-6">
            <div class="popular-card">
              <img v-if="row.image8" :src="row.image8" class="mb-4 img-view img-fluid" :alt="row.title8" />
              <div class="bg-title main-color mb-1" 
                    v-html="row.title8"
                    :style="'color:'+row.color8+' !important'">
              </div>
              <router-link v-if="row.button8" :to="row.redirect8" 
                  class="btn-line btn-line-gray">{{ row.button8 }} 
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Cards -->

  </div>
</template>

<script>
export default {
  name: "Section4",
  props: ['row'],
  components: {},
  data() {
    return {
      pgLoading: true,
    };
  },
  created() {
      //
  },
  methods: {
    //
  },
};
</script>
